<template>
  <div id="vacancy-characteristic-schedule" class="vacancy-edit-characteristics__section-content">
    <div class="vacancy-edit-characteristics__sub-section">
      <div class="vacancy-edit-characteristics__row">
        <div class="vacancy-edit-characteristics__col">
          <BaseSelect :value="inputs.type.value"
                      :options="typesList"
                      @input="onTypeInput"
                      cancelable
                      :getOptionText="getOptionTextForType"
                      text-key="name"
                      class="_shadow"
          />
        </div>
        <div v-if="inputs.type.value && inputs.type.value.id === 4"
             class="vacancy-edit-characteristics__col">
          <BaseSelect :value="computedWeekly"
                      :options="workShifts"
                      @input="onWorkShiftTypeInput"
                      text-key="name"
                      class="_shadow"/>
        </div>
      </div>
    </div>

    <div v-if="inputs.type.value">
      <!--// 1-->
      <div v-for="(shift, index) in shifts"
           :key="shift.id"
           class="vacancy-edit-characteristics__sub-section  _not-first">

        <SelectionDays v-if="!inputs.weekly.value"
                       :value="shift.selected_days"
                       :label="(index + 1) + ' ' + $tNewVacancy('shift')"
                       @input="onChangeSelectedDays(index, $event)"
                       class="vacancy-edit-characteristics__item"/>
        <SliderRange :value="[shift.time_from || workTimeMin, shift.time_to || workTimeMax]"
                     :min="workTimeMin"
                     :max="workTimeMax"
                     :interval="0.5"
                     :formatter="timeFormatter"
                     :reverseFormatter="timeReverseFormatter"
                     @input="onSlide(index, $event)"
                     :label="$tNewVacancy('Working time')"
                     type="text"
                     class="vacancy-edit-characteristics__item
                     vacancy-edit-characteristics__work-time-range"/>
      </div>

      <!--// 2-->
      <div v-if="inputs.type.value && inputs.type.value.id === 2"
           key="02"
           class="vacancy-edit-characteristics__sub-section">
        <div class="vacancy-edit-characteristics__row">
          <div class="vacancy-edit-characteristics__col">
            <BaseSelect :value="inputs.working_days.value"
                        :options="daysQuantity"
                        :getOptionText="daysQuantityGetOptionText"
                        :label="$tNewVacancy('Number of working days')"
                        @input="onInput('working_days', $event)"
                        text-key="name"
                        class="_shadow"/>
          </div>
          <div class="vacancy-edit-characteristics__col">
            <BaseSelect :value="inputs.weekend_interval.value"
                        :options="daysQuantity"
                        :getOptionText="daysQuantityGetOptionText"
                        :label="$tNewVacancy('Weekend interval')"
                        @input="onInput('weekend_interval', $event)"
                        text-key="name"
                        class="_shadow"/>
          </div>
        </div>
      </div>

      <!--// 2-->
      <div v-if="inputs.type.value && inputs.type.value.id === 3"
           key="03"
           class="vacancy-edit-characteristics__sub-section">
        <BaseSelect :value="inputs.minimum_hours.value"
                    :options="minHoursQuantity"
                    :getOptionText="daysQuantityGetOptionHoursText"
                    :label="$tNewVacancy('Minimum hours per day')"
                    @input="onInput('minimum_hours', $event)"
                    text-key="name"
                    class="_shadow"/>
      </div>

      <div style="border: 0; padding-top: 0"
           class="vacancy-edit-characteristics__sub-section">
        <button v-if="!isShowCommentComputed"
                @click.prevent="onAddComment"
                class="base-btn  base-btn--outline-grey base-btn--small">
          <BaseSvg name="ico-comment"
                   width="1.3rem"
                   height="1.4rem"
                   style="position: relative; top: 0.1rem"/>
          <span>{{$tNewVacancy('Add a comment')}}</span>
        </button>
        <TranslateFiled v-else
                        :value="inputs.comment.value"
                        :label="$tNewVacancy('Comment')"
                        textarea
                        rows="5"
                        withFullDelete
                        @input="onInput('comment', $event)"
                        @delete="onDeleteComment('comment')"/>
      </div>
    </div>
  </div>
</template>

<script>
  // import Counter from '../helpers/Counter'
  import {mapState} from 'vuex'
  import SelectionDays from './SelectionDays'
  import SliderRange from './SliderRange'
  import TranslateFiled from './TranslateFiled'

  // const counter = new Counter()

  const workShifts = [{
    name: 'Weekly',
    value: true
  }, {
    name: 'Not weekly',
    value: false
  }]

  const days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]

  export default {
    components: {
      SelectionDays,
      SliderRange,
      TranslateFiled
    },

    data() {
      return {
        workTimeMin: 0,
        workTimeMax: 24,
        isShowComment: false,
      }
    },
    computed: {
      ...mapState('vacancyEdit/characteristicsSchedule/', [
        'muted',
        'inputs',
        'shifts',
        'typesList',
        'daysQuantity',
        'minHoursQuantity',
      ]),
      isShowCommentComputed() {
        return this.isShowComment || this.inputs.comment.value
      },
      computedWeekly() {
        return this.workShifts.find(item => item.value === this.inputs.weekly.value)
      },
      workShifts() {
        return workShifts.map(item => {
          return {
            name: this.$tNewVacancy(item.name),
            value: item.value
          }
        })
      }
    },
    methods: {
      onAddComment() {
        this.isShowComment = true
      },
      onDeleteComment(key) {
        this.isShowComment = false
        this.onInput(key, null)
      },
      onInput(key, value) {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setInputValue', {key, value})
      },

      onSlide(index, value) {
        const fromResult = {index, key: 'time_from', value: value[0]}
        const ftoResult = {index, key: 'time_to', value: value[1]}
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftValue', fromResult)
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftValue', ftoResult)
      },
      onChangeSelectedDays(index, value) {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setSelectedDaysValue', {
          index,
          value
        })
      },
      onWorkShiftTypeInput(value) {
        if (!value.value) {
          this.shifts.forEach((item, index) => {
            const result = {index, value: [false, false, false, false, false, false, false]}
            this.$store.commit('vacancyEdit/characteristicsSchedule/setSelectedDaysValue', result)
          })
        }

        this.onInput('weekly', value.value)
      },

      timeFormatter(value) {
        let hours = Math.floor(value)
        let minutes = Math.floor(60 * (value * 10 % 10 / 10))

        hours = hours.toString().padStart('2', '0')
        minutes = minutes.toString().padStart('2', '0')

        return `${hours}:${minutes}`
      },
      timeReverseFormatter(value) {
        let [hours, minutes] = value.replace(' ', '')
            .split(':')

        hours = parseFloat(hours)
        minutes = minutes / 60

        return hours + minutes
      },

      onTypeInput(type) {
        if(type) {
          switch (type.id) {
            case 1:
              this.setType1()
              break
            case 2:
              this.setType2()
              break
            case 3:
              this.setType3()
              break
            case 4:
              this.setType4()
              break
          }
        }

        this.onInput('type', type)
      },
      setType1() {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftsAll', [createShift()])
      },
      setType2() {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftsAll', [])
      },
      setType3() {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftsAll', [])
      },
      setType4() {
        this.$store.commit('vacancyEdit/characteristicsSchedule/setShiftsAll', [createShift(), createShift()])
      },
      daysQuantityGetOptionText(num) {
        if(!num) return
        return num + ' суток'
      },
      daysQuantityGetOptionHoursText(num) {
        if(!num) return
        return num + ' часа'
      },
      createResult() {
        const value = {
          type: this.inputs.type.value
        }

        if (!Array.isArray(value.time_from)) value.time_from = []
        if (!Array.isArray(value.time_to)) value.time_to = []
        days.forEach(day => {
          if (!Array.isArray(value[day])) value[day] = []
        })

        this.computedValue.shifts.forEach((item, index) => {
          value.time_from[index] = item.workTime[0]
          value.time_to[index] = item.workTime[1]

          days.map((day, dayIndex) => {
            value[day][index] = item.selectedDays[dayIndex]
          })
        })

        return value
      },
      getOptionTextForType(option) {
        return option ? this.$tSchedule_types(option.name) : null
      }
    },
    created() {
      // this.onTypeInput(this.inputs.type.value)
      this.$store.commit('vacancyEdit/characteristicsSchedule/setMuted', false)
    }
  }

  function createShift() {
    return {
      time_from: 0,
      time_to: 24,
      selected_days: [false, false, false, false, false, false, false]
    }
  }

  // function createDafultValue() {
  //   return inputs: {
  //     type: {
  //       value: scheduleList[0]
  //     },
  //     'time_from': {
  //       value: null
  //     },
  //     'time_to': {
  //       value: null
  //     },
  //     working_days: {
  //       value: 1
  //     },
  //     weekend_interval: {
  //       value: 1
  //     },
  //     minimum_hours: {
  //       value: 1
  //     },
  //     shift_count: {
  //       value: null
  //     },
  //     weekly: {
  //       value: null
  //     },
  //     comment: {
  //       value: null
  //     }
  //   }
  // }

</script>

<style lang="less">

</style>
